import { render, staticRenderFns } from "./DocumentInsert.vue?vue&type=template&id=a271ae34&scoped=true&"
import script from "./DocumentInsert.vue?vue&type=script&lang=js&"
export * from "./DocumentInsert.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInsert.vue?vue&type=style&index=0&id=a271ae34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a271ae34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
